import { render, staticRenderFns } from "./RecommendationLibraryListPrintable.vue?vue&type=template&id=686d83d8&scoped=true&"
import script from "./RecommendationLibraryListPrintable.vue?vue&type=script&lang=js&"
export * from "./RecommendationLibraryListPrintable.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationLibraryListPrintable.vue?vue&type=style&index=0&id=686d83d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d83d8",
  null
  
)

export default component.exports